var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChannels({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 673.23 675.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.69.67c142.91-8.75,301.23,69.01,346.7,211.4,54.81,171.65-73.8,322.63-235.62,360.64-26.33,25.44-49.37,73.62-74.98,97.12-8.76,8.04-17.45,8.09-26.28,0-25.53-23.41-48.86-71.66-74.98-97.12C89.97,535.4-38.02,389.16,10.37,219.77,47.81,88.68,183.04,8.67,313.69.67ZM315.74,33.45C11.34,51.52-81.64,414.1,211.17,526.07c14.19,5.42,45.7,11.4,55.72,18.03,19.46,12.88,46.24,65.67,65.67,83.88,1.46,1.37,2.35,3.56,4.92,3.01l68.93-86.89c151.26-33.08,278.67-170.45,219.15-332.03-45.06-122.33-185.27-186.02-309.82-178.63Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannels);
export default __webpack_public_path__ + "static/media/channels.4d16eb2d18b2cbe1b6e30c845c642d9b.svg";
export { ForwardRef as ReactComponent };